import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Switch from 'app/scripts/components/common/inputs/customs/switch';
import { autobind } from 'core-decorators';
import { withEditSpot } from '../../../spots/hoc/withEditSpot';

class Emoji extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static defaultProps = {
    value: true
  };

  static propTypes = {
    value: PropTypes.bool.isRequired,
    spotId: PropTypes.string.isRequired
  };

  static displayName = 'Emoji';

  @autobind
  onChange(emojiKeyboardEnabled) {
    const { spotId } = this.props;
    this.props.editSpot(spotId, {
      emoji_keyboard_enabled: emojiKeyboardEnabled,
      emojis_enabled: emojiKeyboardEnabled
    });
  }

  render() {
    const { value } = this.props;
    return (
      <Switch
        title="Insert emojis"
        description="Allow adding emojis in the conversation"
        value={value}
        onChange={this.onChange}
      />
    );
  }
}

export default withEditSpot(Emoji);
